export function SkipToMain() {
  return (
    <a
      href="#admin-main"
      className="fixed top-3 left-3 z-[100] -translate-y-20 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-transform focus:translate-y-0"
    >
      Skip to main content
    </a>
  );
}
